import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore';
import {
  SheetPortal,
  SheetOverlay,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetContentWrapper,
  SheetClose,
  Typography,
  tk,
} from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { getRoomExtraInfo } from '../selectors';
import { SheetContentTitle, FieldSection, FieldSectionTitle } from './SheetPortal';
import styled from 'styled-components';

export function RoomExtraInfoSheetPortal() {
  const roomExtraInfo = useGroupResponsibleStore(getRoomExtraInfo);

  const intl = useIntl();

  return (
    <SheetPortal>
      <SheetOverlay />
      <SheetContent $side="right">
        <SheetHeader>
          <SheetTitle>{intl.formatMessage({ id: 'groups_responsible_room' })}</SheetTitle>
          <SheetClose>{intl.formatMessage({ id: 'close' })}</SheetClose>
        </SheetHeader>
        <SheetContentWrapperStyled>
          <SheetContentTitle as="div" $variant="heading-lg">
            {roomExtraInfo.name}
          </SheetContentTitle>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_hosts' })}
            </FieldSectionTitle>
            {roomExtraInfo.participants.length > 0 ? (
              roomExtraInfo.participants.map((participant) => (
                <Typography as="div" key={participant}>
                  {participant}
                </Typography>
              ))
            ) : (
              <Typography>-</Typography>
            )}
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_room_type' })}
            </FieldSectionTitle>
            <Typography>{roomExtraInfo.type}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_accommodation' })}
            </FieldSectionTitle>
            <Typography>{roomExtraInfo.accommodationName}</Typography>
          </FieldSection>
        </SheetContentWrapperStyled>
      </SheetContent>
    </SheetPortal>
  );
}

const SheetContentWrapperStyled = styled(SheetContentWrapper)`
  padding: ${tk('spacing_md')};
`;
